import React, { useEffect} from "react";
import { connect } from "react-redux";
import { getWeeklyAttendance } from "../../../../redux/overview/overviewState";
import HeaderComponent from "components/card/HeaderComponent";
import BarChartBase from "components/charts/BarChartBase";

const WeeklyAttendanceOverview = ({
  recordList,
  doSearch,
}) => {
  
  useEffect(() => {
    doSearch();
  }, [doSearch]);

  const data =
    recordList?.overview?.map((item) => ({
      day: item.day,
      Present: item.present,
      Absent: item.absent,
    })) || [];
  
  const hasData = data.some(
    (item) => item.Present > 0 || item.Absent > 0
  );

  return (
      <HeaderComponent
        title="Weekly Attendance Overview"
        description="Present vs Absent employees this week"
      >
        {hasData ? (
          <BarChartBase
            data={data}
            xKey="day"
            height={330}
            yKeys={["Present", "Absent"]}
            barColors={["#8b5cf6", "#a78bfa"]}
          />
        ) : (
          <div className="h-[330px] flex items-center justify-center text-gray-500">
            No attendance data available this week.
          </div>
        )}
      </HeaderComponent>
 
  );
};

const mapStateToProps = (state) => ({
  recordList: state.overview.weeklyAttendanceRecord?.data,
  requesting: state.overview.weeklyAttendanceRecord?.requesting,
  error: state.overview.weeklyAttendanceRecord?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getWeeklyAttendance(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WeeklyAttendanceOverview);